import { SparePartType } from '@savgroup-front-common/types';

import sparePartTypeMessages from '../helpers/i18n/messages/sparePartTypeMessages';

import { safeFormattedIntlString } from './safeFormattedIntlString';

const getSparePartTypeMessage = (
  type: SparePartType,
): ReturnType<typeof safeFormattedIntlString> => {
  let message;

  switch (type) {
    case SparePartType.KIT: {
      message = sparePartTypeMessages.Kit;
      break;
    }
    case SparePartType.ACCESSORY: {
      message = sparePartTypeMessages.Accessory;
      break;
    }
    case SparePartType.CONSUMABLE: {
      message = sparePartTypeMessages.Consumable;
      break;
    }
    case SparePartType.FUNCTIONAL: {
      message = sparePartTypeMessages.Functional;
      break;
    }
    case SparePartType.AESTHETIC: {
      message = sparePartTypeMessages.Aesthetic;
      break;
    }
    case SparePartType.NONE: {
      message = sparePartTypeMessages.none;
      break;
    }
    default:
      throw new Error(`Spare parts type ${type} does not exist`);
      break;
  }

  return safeFormattedIntlString(message);
};

export default getSparePartTypeMessage;
